module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.4.1-240.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.4.1.md
// module id = 681
// module chunks = 292